/** reactEcharts */
import './echarts.scss'
import React from 'react';
import * as echarts from 'echarts';
import {Empty} from "antd";

class ReactEcharts extends React.Component{
  inputId = Math.random().toString(36).substring(3, 8);
  myChart;
  componentDidMount = () => {
    this.initChart();
  };
  initChart() {
    const chartDom = document.getElementById(this.inputId);
    this.myChart = echarts.init(chartDom);
    this.myChart.setOption(this.props.option);
  };
  // 数据改变时 重绘
  updateEcharts = () => {
    this.myChart.setOption(this.props.option);
  };
  render() {
    const {isHide} = this.props;
    return (
      <div className='react-echarts card' style={{width: this.props.w || '100%'}}>
        <div id={this.inputId} className={isHide ? 'hide' : ''}
             style={{height: this.props.h || 500}}></div>
        <Empty className={!isHide ? 'hide' : ''} />
      </div>

    );
  }
};
export default ReactEcharts;
